"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var is_html_element_1 = require("../is-html-element");
function getParentsOrSelf(element) {
    var parents = [];
    if (element && is_html_element_1.default(element)) {
        parents.push(element);
        if (element.parentElement) {
            parents.push.apply(parents, getParentsOrSelf(element.parentElement));
        }
    }
    return parents;
}
exports.default = getParentsOrSelf;
